import { GAME_CONFIG_MIGRATION } from './game-migrator.config';
import { GameData } from '../data';

export class GameMigratorService {
  static initMigration(gameData: GameData): GameData {
    if (!gameData) {
      return new GameData<any>();
    }
    let currentVersion = gameData.version;
    if (!currentVersion) {
      currentVersion = GAME_CONFIG_MIGRATION[0].from;
    }
    let migrator = GAME_CONFIG_MIGRATION.find(m => m.from === currentVersion);
    while (migrator) {
      currentVersion = gameData.version;
      if (!migrator.type || gameData.config.gameType === migrator.type) {
        gameData = migrator.function(gameData);
      }
      gameData.version = migrator.to;
      migrator = GAME_CONFIG_MIGRATION.find(m => m.from === migrator.to);
      if (currentVersion === gameData.version) {
        migrator = null;
      }
    }

    return gameData;
  }
}
